import { useEffect, useState } from "react";
import "./ReportAllLeaves.scss";
import loadingImg from "./../../assets/images/loading-spinner.gif";
import LoginInDialog from "../Login/LoginInDialog";
import Loading from "components/GeneralComponents/Loading";
import Axios from "middleware/axiosInstance";

const ReportAllLeaves = () => {
  // check if authentication is expired
  const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

  const [allLeaves, setAllLeaves] = useState();

  const getLeaves = () => {
    Axios.get(`user/leaves?api_token=${localStorage.getItem("token")}`)
      .then((response) => {
        setAllLeaves(response.data.data.reverse());
        setAuthenticationIsExpired(false);
      })
      .catch((error) => {
        error.response.status === 401
          ? setAuthenticationIsExpired(true)
          : alert("عملیات انجام نشد!");
        // history.push("/services")
      });
  };

  useEffect(() => {
    if (!navigator.onLine) {
      alert("به اینترنت متصل نمی باشید");
    } else {
      getLeaves();
    }
  }, []);

  return (
    <div className="allLeavesContainer">
      <p>درخواست های من:</p>
      {allLeaves ? (
        allLeaves.map((leave) => {
          return (
            <div
              className={
                leave.status === "تایید شده"
                  ? "approvedLeave leaveCard"
                  : leave.status === "در انتظار"
                  ? "leaveCard"
                  : "unapprovedLeave leaveCard"
              }
            >
              <ul>
                <li>
                  <span>شماره مرخصی:</span>
                  {` ${leave.number}`}
                </li>
                <li>
                  <span>شروع:</span>
                  {` ${leave.from}`}
                </li>
                <li>
                  <span>پایان:</span>
                  {` ${leave.to}`}
                </li>
                <li>
                  <span>نتیجه بررسی:</span>
                  {` ${leave.status}`}
                </li>
                {leave.description ? (
                  <li>
                    <span>توضیحات: </span>
                    {leave.description}
                  </li>
                ) : null}
                <li>
                  <span>زمان درخواست:</span>
                  {` ${leave.created_at}`}
                </li>
              </ul>
            </div>
          );
        })
      ) : (
        <Loading />
      )}
      {/* show login dialog box if token not valid */}
      {authenticationIsExpired && <LoginInDialog />}
    </div>
  );
};

export default ReportAllLeaves;
